// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--8vRDP";
export var copyrightLink = "Footer-module--copyrightLink--gZi91";
export var footer = "Footer-module--footer--YzaGB";
export var up = "Footer-module--up--lznvQ";